import React from 'react';
import { Card, Typography, Button, Box, Stack, Chip } from '@mui/material';
import { alpha } from '@mui/material/styles';
import EditIcon from '@mui/icons-material/Edit';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';

interface IPricing {
  hpOvenPricing: number;
  nonHpOvenPricing: number;
}

interface PricingCardProps {
  pricing: IPricing;
  setOpenPrice: (open: boolean) => void;
}

export const PricingCard: React.FC<PricingCardProps> = ({ pricing, setOpenPrice }) => {
  const priceItems = [
    { label: 'HP Oven', value: pricing.hpOvenPricing, color: '#bf360c' },
    { label: 'Non-HP Oven', value: pricing.nonHpOvenPricing, color: '#e65100' },
  ];

  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: 3,
        border: '1px solid',
        borderColor: 'grey.200',
        overflow: 'hidden',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* Header */}
      <Box
        sx={{
          px: 2.5, py: 2,
          bgcolor: alpha('#00695c', 0.04),
          borderBottom: '1px solid', borderColor: 'grey.200',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Box
            sx={{
              width: 36, height: 36, borderRadius: 2,
              bgcolor: alpha('#00695c', 0.1),
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}
          >
            <LocalOfferIcon sx={{ color: '#00695c', fontSize: 18 }} />
          </Box>
          <Box>
            <Typography variant="subtitle2" fontWeight={700}>Today's Pricing</Typography>
            <Typography variant="caption" color="text.secondary">Current oven rates</Typography>
          </Box>
        </Box>
        <Button
          variant="outlined"
          size="small"
          startIcon={<EditIcon fontSize="small" />}
          onClick={() => setOpenPrice(true)}
          sx={{
            borderRadius: 2,
            borderColor: 'grey.300',
            color: 'text.secondary',
            fontSize: 12,
            '&:hover': { borderColor: '#00695c', color: '#00695c', bgcolor: alpha('#00695c', 0.04) },
          }}
        >
          Edit
        </Button>
      </Box>

      <Box sx={{ p: 2.5, flex: 1 }}>
        <Stack spacing={2}>
          {priceItems.map((item) => (
            <Box
              key={item.label}
              sx={{
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                p: 2, borderRadius: 2,
                bgcolor: alpha(item.color, 0.04),
                border: '1px solid', borderColor: alpha(item.color, 0.15),
              }}
            >
              <Typography variant="body2" fontWeight={500} color="text.secondary">
                {item.label}
              </Typography>
              <Chip
                label={`₹${item.value}`}
                size="small"
                sx={{
                  bgcolor: alpha(item.color, 0.12),
                  color: item.color,
                  fontWeight: 700,
                  fontSize: 14,
                  height: 28,
                }}
              />
            </Box>
          ))}
        </Stack>
      </Box>
    </Card>
  );
};
